
import React, { useState, useEffect } from "react";
import * as Fa from "react-icons/fa";
import { Calendar } from "primereact/calendar";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import storage from "../../Services/Storage";
import { Dialog } from "primereact/dialog";
import { createAPIEndpointOddLotConversion, EndpointOddLotConversion } from "../../Services/OddLotConversion/OddLotConversionService";
import { AutoComplete } from "primereact/autocomplete";
import { toast } from "react-toastify";
import { createAPIEndpoint, Endpoint } from "../../Services/StockAdjustmentService.js/StockAdjustmentService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const OddLotConversion = () => {
    const [date, setDate] = useState(new Date());
    const auth = storage.getLocal("user");
    const [wareHouseData, setWareHouseData] = useState();
    const [selectedWareHouse, setSelectedWareHouse] = useState("");
    // const [selectedReason, setSelectedReason] = useState("");
    const [productListOddLotData, setProductListOddLotData] = useState();
    const [selectedProductOddLot, setSelectedProductOddLot] = useState();
    // const [packFactorValue, setPackFactorValue] = useState();
    // const [productCode, setProductCode] = useState("");
    // const [productLotNo, setProductLotNo] = useState("");
    const [stockQty, setStockQty] = useState(0);
    const [oddLotQty, setOddLotQty] = useState(0);
    const [wastagetxt, setWastagetxt] = useState("");
    // const [grn, setGrn] = useState("");
    const [yREndTag, setYREndTag] = useState();
    const [visible, setVisible] = useState(false);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    // const [debouncedStockQty, setDebouncedStockQty] = useState("");
    // const [debouncedOddLotQty, setDebouncedOddLotQty] = useState("");
    // const [timer, setTimer] = useState(null);
    const [selectedReasonData, setSelectedReasonData] = useState();
    const [reasonData, setReasonData] = useState();
    const [grnData, setGRNdata] = useState();
    const [selectedGRN, setSelectedGRN] = useState();
    const [addRecordData, setAddRecordData] = useState([]);
    const [grnVisible,setGrnVisible] = useState(false);
    let strDate = new Intl.DateTimeFormat("en-GB").format(date);
    

    const searchProducts = (event) => {
        let query = event.query.toLowerCase();
        let _filteredProducts = productListOddLotData?.filter(product =>
            product.DESCRIPTION.toLowerCase().includes(query)||
            product.MASK_PROD_ID.toLowerCase().includes(query)
        );
        setFilteredProducts(_filteredProducts);
    };

    const handleStockQtyChange = (e) => {
        const value = e.target.value;
        setStockQty(value);
    };

    const handleLotQyChange = (e) => {
        const value = e.target.value;
        setOddLotQty(value);
    };
    const onQtyChange = async (stkQty,oddLotQty) =>{
        if(stkQty===null||stkQty===undefined||stkQty===""||oddLotQty===null||oddLotQty===undefined||oddLotQty===""){
            return;
        }
        if(parseFloat(selectedProductOddLot.STK_BALANCE_QTY)<parseFloat(stkQty)){
            toast.warn("Quantity for odd lot conversion should be less than or equal to quantity available in stock", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            setSelectedGRN("");
            setGrnVisible(false);
            return;
        }
        const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetPackfactor}?ProdId=${selectedProductOddLot?.MASK_PROD_ID}&CompId=${auth.CompId}`);
        console.log(res,"selectedProductOddLot");
        if(res.data.Data.length>0){
            let m_UomFactor = parseFloat(stkQty) * res.data.Data[0]?.PACK_FACTOR;
            if(parseFloat(oddLotQty==""?0:oddLotQty)==0){
                oddLotQty = "0";
            }
            let m_OddLot = parseFloat(oddLotQty);
            if(m_UomFactor < m_OddLot){
                toast.warn("Quantity for odd lot conversion should be less than or equal to quantity available in stock", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setSelectedGRN("");
                setGrnVisible(false);
                return;
            }
            let m_Wastage = m_UomFactor - m_OddLot;
            if (m_Wastage < 0){
                toast.warn("Physical stock quantity should not be less than 0.00", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setSelectedGRN("");
                setGrnVisible(false);
                return;
            }
            else{
                if (m_Wastage == 0)
                {
                    setWastagetxt("0.00");
                }
                else
                {
                    setWastagetxt(m_Wastage.toString().trim());
                }
                getGRN();
                setGrnVisible(true);
            }
        }
    };

    const getWarehouseData = async () => {
        try {
            const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.PopulateWarehouseData}?UserId=${auth.UserId}&CompId=${auth.CompId}`);
            console.log("res.datra ", res.data);
            setWareHouseData(res.data.Data);
            const ress = await createAPIEndpointOddLotConversion().getDefaultValue(`${EndpointOddLotConversion.WhDefaultVal}?CompId=${auth.CompId}&UserId=${auth.UserId}`);
            const defWh = res.data.Data.find((val)=>{
                return val.MASK_WH_ID === ress.data.Id;
            });
            console.log(defWh,"defWh");
            setSelectedWareHouse(defWh);
        } catch (error) {
            console.log("error ", error);
        }
    };

    const getProductListOddLot = async () => {
        try {
            // const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetProductListOddLot}?CompId=${auth.CompId}&WHId=${selectedWareHouse?.MASK_WH_ID}&ProdId=""`);
            const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetProductListOddLot}?CompId=${"20119962"}&WHId=${"20119962|W1"}&ProdId=""`);
            console.log("res getProductListOddLot", res.data);
            setProductListOddLotData(res.data.Data);


        } catch (error) {
            console.log("error ", error);
        }
    };

    // const getPackfactor = async () => {
    //     try {
    //         const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetPackfactor}?ProdId=${selectedProductOddLot?.MASK_PROD_ID}&CompId=${auth.CompId}`);
    //         console.log("res data getPackfactor ", res.data);
    //         setPackFactorValue(res.data.Data);

    //     } catch (error) {
    //         console.log("error ", error);
    //     }
    // };

    const addProductValidationCheck = () => {
        if (selectedProductOddLot?.PROD_CODE == "") {
            toast.error("Product cannot left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (selectedProductOddLot?.PROD_BATCH_NO == "") {
            toast.error("Product Lot No cannot left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (stockQty == "") {
            toast.error("Stock Quantity cannot left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (oddLotQty === "") {
            toast.error("Odd Lot Quantity cannot left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (wastagetxt == "") {
            toast.error("Wastage cannot left blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (selectedGRN == "") {
            toast.error("Please Select a GRN", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }

        return true;

    };

    
    // const convertToDecimal = (number) => {
    //     return Number(number).toFixed(2);
    // };

    const onSaveValidationCheck = () => {
        console.log("selected Reason ",selectedReasonData);
        if (selectedWareHouse.BRANCH_NAME == "") {
            toast.error("Please,Select a warehouse", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (selectedReasonData?.REASON_DESC == "" ) {
            toast.error("Please,Select a Reason", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        GetYREndTag();
        if (yREndTag?.length != 0) {
            if (yREndTag?.Column1 == "Y") {
                toast.error("You Can't create odd lot for the last financial year as it's already closed", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return false;
            }
        }
        if (stockQty > selectedProductOddLot?.STK_BALANCE_QTY) {
            toast.error("Quantity for odd lot conversion should be less than or equal to quantity available in stock", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        if (oddLotQty <= 0) {
            toast.error("Zero or negative quantity for odd lot conversion not allowed", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return false;
        }
        return true;
    };

    const createPayload = () => {
        console.log("addRecordDataaddRecordDataaddRecordData from payload ",addRecordData);
        return {
            ciCode: auth.CICode,
            compId: auth.CompId,
            userId: auth.UserId,
            brancH_ID: selectedWareHouse?.MASK_BRANCH_ID,
            divN_ID: "LUB|C",
            wH_ID: selectedWareHouse?.MASK_WH_ID,
            strDate: strDate,
            reasonId: selectedReasonData?.MASK_REASON_ID,
            reason: selectedReasonData?.REASON_DESC,
            lstStkDetails: [
                {
                    stK_ADJ_ITM_SLNO: "1",
                    masK_STK_TYPE_ID: "5",
                    stocK_TYPE: addRecordData[0]?.stockType,
                    masK_PROD_ID: addRecordData[0]?.MASK_PROD_ID,
                    proD_CODE: addRecordData[0]?.productCode,
                    producT_DESCRIPTION: addRecordData[0]?.productDescription,
                    batcH_NO: addRecordData[0]?.productLotNumber,
                    stocK_QUANTITY: addRecordData[0]?.stockQty?.toString(),
                    odD_LOT_QUANTITY: addRecordData[0]?.oddLotQty?.toString(),
                    wastagE_QUANTITY: addRecordData[0]?.wastage,
                    avaiL_STK_QTY: addRecordData[0]?.STK_BALANCE_QTY.toString(),
                    grN_ID: addRecordData[0]?.grn?.GRN_NO,
                    grnD_ID: addRecordData[0]?.grn?.GRND_ID,
                    proD_PRICE: addRecordData[0]?.grn?.PRICE.toString(),
                    proD_TAX: addRecordData[0]?.grn?.PROD_TAX.toString(),
                },
            ],
        };
      
    };
      
    const saveData = () => {
        const payload = createPayload();
        console.log("payload ", payload);
        const isValid = onSaveValidationCheck();
        if (!isValid) {
            console.log("eeror");
            return;
        }else {
            console.log("success");
            createAPIEndpointOddLotConversion().post(`${EndpointOddLotConversion.SaveOddLotData}`,payload);
        }
    };

    const removeData = () => {
        setAddRecordData([]);
        setSelectedProductOddLot("");
        setSelectedGRN("");
        setWastagetxt("");
        setStockQty("");
        setOddLotQty("");
        setSearchTerm("");

    };

    const onProductChange = (e) => {
        console.log("producthange called");
        setSelectedGRN("");
        setStockQty(0);
        setOddLotQty(0);
        setWastagetxt("");
        setSearchTerm(e.value);
    };

    const GetYREndTag = async () => {
        const formattedDate = new Intl.DateTimeFormat("en-GB").format(date);
        try {
            const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetYREndTag}?CompId=${auth.CompId}&strDate=${formattedDate}`);
            setYREndTag(res.data.Data);

        } catch (error) {
            console.log("error ", error);
        }
    };

    const handleAddRow = () => {
        console.log("selectedReasonData ", selectedReasonData);
        if (selectedReasonData == undefined) {
            toast.error("Please Select Reason", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (selectedWareHouse == "") {
            toast.error("Please Select warehouse", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (addRecordData.length > 0) {
            toast.error("Cannot add more than one data", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        getProductListOddLot();
        setVisible(true);
    };

    // const GetProdTransDate = async () => {
    //     try {
    //         const res = await createAPIEndpointOddLotConversion()
    //             .get(`${EndpointOddLotConversion.GetProdTransDate}
    //             ?CompId=${auth.CompId}ProdId=${selectedProductOddLot?.MASK_PROD_ID}&StkTypeId=${"1"}&WareHouseId=${selectedWareHouse?.MASK_WH_ID}&LocId=${"N"}&EvalTag=${"P"}"
    //             &BatchNo=${selectedProductOddLot?.PROD_BATCH_NO}&DivnId=${""}&m_dteDate=${strDate}`);
    //         console.log("GetProdTransDateGetProdTransDateGetProdTransDate ",res.data);

    //     } catch (error) {
    //         console.log("error ", error);
    //     }
    // };


    const handleChange = (e) => {
        console.log("e.value ",e);
        setSelectedWareHouse(e.value);
    };

    const ReasonTemplate = (filtered) => {
        return (
            <>
                {filtered.REASON_CODE}{" "}-{" "}{filtered.REASON_DESC}
            </>
        );
    };

    const GRNTemplate = (filtered) => {
        return (
            <>
                {filtered.GRN_NO}
            </>
        );
    };

    const getAllReasonData = () => {
        createAPIEndpoint()
            .get(`${Endpoint.GetAllReasonData}`)
            .then((res) => {
                console.log("Reason", res.data);
                setReasonData(res.data.Data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getGRN = () => {
        // createAPIEndpoint()
        //     .get(`${Endpoint.GetGRN}?prodid=${selectedProductOddLot?.PROD_CODE}&prodlot=${selectedProductOddLot?.PROD_BATCH_NO}&CompId=${auth.CompId}`)
        //     .then((res) => {
        //         console.log("res.data.Data ",res.data)
        //         setGRNdata(res.data.Data);
        //     });
        createAPIEndpoint()
            .get(`${Endpoint.GetGRN}?prodid=${"3371770"}&prodlot=${"2023005"}&CompId=${auth.CompId}`)
            .then((res) => {
                console.log("res.data.Data ", res.data);
                setGRNdata(res.data.Data);
            });
    };

    const footerContent = (
        <div className="text-end">
            <button type="button" className="btn btn-primary me-3" onClick={() => handleAddData()}>Ok</button>
            <button type="button" className="btn btn-cancel-red" onClick={() => setVisible(false)}>Close</button>
        </div>
    );

    const updateAddRecordData = () => {
        console.log("selectedProductOddLotselectedProductOddLotselectedProductOddLot ",selectedProductOddLot);
        console.log(stockQty,oddLotQty,"qty");
        setAddRecordData([{
            row: 1,
            stockType: "Inventory",
            productCode: selectedProductOddLot?.PROD_CODE || "",
            productDescription: searchTerm.DESCRIPTION,
            productLotNumber: selectedProductOddLot?.PROD_BATCH_NO || "",
            stockQty: stockQty===0?stockQty:stockQty.replace(/^0+/, ""),
            oddLotQty: oddLotQty===0?oddLotQty:oddLotQty.replace(/^0+/, ""),
            wastage: wastagetxt,
            grn: selectedGRN,
            STK_BALANCE_QTY: selectedProductOddLot?.STK_BALANCE_QTY,
            MASK_PROD_ID: selectedProductOddLot?.MASK_PROD_ID
        }]);
    };

    useEffect(()=> {
        console.log("setAddRecordDatasetAddRecordDatasetAddRecordData ", addRecordData);
    },[addRecordData]);

    const handleAddData = () => {
        console.log("calling handleAdd Data");
        const isValid = addProductValidationCheck();
        console.log("isValid ", isValid);
        if(isValid) {
            updateAddRecordData();
            setVisible(false);
        }
    };

    
    useEffect(() => {
        getWarehouseData();
        getProductListOddLot();
        // getPackfactor();
        getAllReasonData();
        // GetProdTransDate();
    }, []);
    const itemTemplate = (item) => <div>{item.MASK_PROD_ID}-{item.DESCRIPTION}-{item.PROD_BATCH_NO}</div>;
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mx-1">
                                <li className="breadcrumb-item">
                                    <Link to="/inventorymanagement/OddLotConversionAllRecords">Odd Lot Conversion</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <Link to="/inventorymanagement/OddLotConversionAllRecords">
                                <button type="submit" className="btn btn-primary">
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All Records
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Document Number</label>
                                <InputText className="form-control" type="text" placeholder=""
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Date</label>
                                <Calendar value={date}
                                    onChange={(e) => {
                                        strDate = new Intl.DateTimeFormat("en-GB").format(e.value);
                                        
                                        console.log("formattedDateformattedDateformattedDate ",strDate);

                                        setDate(e.value);}}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Warehouse</label>
                                <Dropdown
                                    value={selectedWareHouse}
                                    options={wareHouseData}
                                    onChange={(e) => handleChange(e)}
                                    optionLabel="DESCRIPTION"
                                    placeholder="Select a warehouse"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Reason</label>
                                <Dropdown
                                    name="reason"
                                    value={selectedReasonData}
                                    options={reasonData}
                                    optionLabel="REASON_DESC"
                                    onChange={(e) => {
                                        setSelectedReasonData(e.target.value);
                                    }}
                                    dropdown={true}
                                    itemTemplate={ReasonTemplate}
                                    emptyMessage="No results found."
                                    showEmptyMessage
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="float-end mt-2">
                                <button type="submit" title='Add Row' className="btn btn-outline-primary me-3" onClick={handleAddRow}>
                                    Add Row
                                </button>
                                <button type="submit" title='Save' className="btn btn-primary" onClick={saveData} >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                {addRecordData.length > 0 && 
                    <section className="">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3>Records</h3>
                            <div className="DataTable">
                                <DataTable
                                    // paginator
                                    rows={10}
                                    value={addRecordData}
                                    // rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    // showGridlines
                                    scrollable
                                    stripedRows
                                    emptyMessage="No Record found"
                                >
                                    <Column field="stockType" header="Stock Type"></Column>
                                    <Column field="productCode" header="Product Code"/>
                                    <Column field="productDescription" header="Product Description"></Column>
                                    <Column field="productLotNumber" header="Product Lot Number"/>
                                    <Column field="stockQty" header="Stock QTY (Packs)"/>
                                    <Column field="oddLotQty" header="Odd Lot (UOM)"></Column>
                                    <Column field="wastage" header="Wastage (UOM)"/>
                                    <Column header="Action" body={() => (
                                        <>
                                            <img
                                                alt="View/Edit"
                                                width="20px"
                                                src={require("../../Assets/Images/ViewEdit.png")}
                                                onClick={() => setVisible(true)}
                                                style={{ cursor: "pointer", marginRight: "10px" }}
                                            />
                                            <i className="pi pi-times" style={{ color: "red", cursor: "pointer",marginLeft: "4px" }} onClick={() => removeData()}></i>
                                        </>
                                    )}/>
                                </DataTable>
                            </div>
                        </div>
                    </section>
                    
                }

            </div>

            <Dialog
                header="Information"
                visible={visible}
                onHide={() => { setVisible(false); }}
                style={{ width: "50vw" }}
                closable={false}
                draggable={false}
                resizable={false}
                footer={footerContent}
            >
                <form>
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Row</label>
                                <InputText className="form-control" value="1" disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Stock Type</label>
                                <InputText className="form-control" value="Inventory" disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Product Code</label>
                                <InputText className="form-control" value={selectedProductOddLot?.PROD_CODE} disabled />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Product Description</label>
                                <AutoComplete value={searchTerm}
                                    suggestions={filteredProducts}
                                    completeMethod={searchProducts}
                                    field="DESCRIPTION"
                                    onChange={(e) => onProductChange(e)}
                                    onSelect={(e) => setSelectedProductOddLot(e.value)}
                                    dropdown
                                    itemTemplate={itemTemplate}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Product Lot Number</label>
                                <InputText className="form-control" value={selectedProductOddLot?.PROD_BATCH_NO} disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Stock Quantity (In Packs)</label>
                                <InputText className="form-control" type="number" value={stockQty} onChange={(e) => {handleStockQtyChange(e);onQtyChange(e.target.value,oddLotQty);}} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Odd Lot Quantity (Ltr)</label>
                                <InputText className="form-control" type="number" value={oddLotQty} onChange={(e) => {handleLotQyChange(e);onQtyChange(stockQty,e.target.value);}} />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Wastage(Ltr)</label>
                                <InputText className="form-control" value={wastagetxt} disabled />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            {grnVisible && <div className="d-block mb-2">
                                <label className="form-label">GRN</label>
                                <Dropdown
                                    name="GRN"
                                    options={grnData}
                                    optionLabel="GRN_NO"
                                    value={selectedGRN}
                                    onChange={(e) => {
                                        { setSelectedGRN(e.target.value); }

                                    }}
                                    itemTemplate={GRNTemplate}
                                    emptyMessage='No results found.'
                                    showEmptyMessage
                                />
                            </div>}
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    );
};

export default OddLotConversion;